import http from '../httpService';

class PreInvoicesService {
  async persistAndGetId(input) {
    return await http.post(
      '/api/services/app/PreInvoices/PersistAndGetId',
      input
    );
  }

  async savePreInvoice(input) {
    const result = await http.post(
      '/api/services/app/pos/SavePreInvoice',
      input
    );
    return result.data.result;
  }

  async getAllOrders(input) {
    return await http.get('/api/services/app/PreInvoices/GetAll', {
      params: input,
    });
  }

  async getAllFavourites(params) {
    return await http.get('/api/services/app/FavouriteProducts/GetAll', {
      params: { ...params, MaxResultCount: 1000 },
    });
  }

  async toggleFavourite(payload) {
    return await http.post(
      '/api/services/app/FavouriteProducts/PersistAndGetId',
      payload
    );
  }

  async deleteFavourite(id) {
    return await http.delete('/api/services/app/FavouriteProducts/Delete', {
      params: { id: id },
    });
  }

  async saveUserAddress(payload) {
    return await http.post(
      '/api/services/app/UserAddresses/PersistAndGetId',
      payload
    );
  }

  // async getUserAddress(input) {
  //   return await http.get('/api/services/app/UserAddresses/GetAll', {
  //     params: input || {},
  //   });
  // }
}

export default new PreInvoicesService();
